import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Tracks product IDs that appear in the وصل حديثاً (Recently Added) section
 * so the New / جديد badge can render on those products site-wide.
 */
@Injectable({ providedIn: 'root' })
export class NewArrivalsBadgeService {
  private readonly idsSubject = new BehaviorSubject<ReadonlySet<number>>(new Set());

  /** Emits whenever the registered id set changes (for OnPush cards). */
  readonly changes$: Observable<ReadonlySet<number>> = this.idsSubject.asObservable();

  /** Snapshot for synchronous card checks. */
  get ids(): ReadonlySet<number> {
    return this.idsSubject.getValue();
  }

  register(productIds: Iterable<number> | null | undefined): void {
    if (!productIds) {
      return;
    }
    const next = new Set(this.idsSubject.getValue());
    let changed = false;
    for (const raw of productIds) {
      const id = Number(raw);
      if (!id || id <= 0 || next.has(id)) {
        continue;
      }
      next.add(id);
      changed = true;
    }
    if (changed) {
      this.idsSubject.next(next);
    }
  }

  has(productId: number | null | undefined): boolean {
    const id = Number(productId);
    return !!id && this.idsSubject.getValue().has(id);
  }
}
